import { Component, OnInit } from "@angular/core";
import { TitleService } from 'src/app/_services/title.service';

@Component({
  selector: "mail-settings-layout",
  templateUrl: "./mail-settings.layout.html",
  host: { 'class': 'tab-content' },
  styleUrls: ['./mail-settings.layout.scss']
})
export class MailSettingsLayout implements OnInit {
  title = "cards.lexi_market_settings.mail_settings.title";

  constructor(private _titleService: TitleService) { }

  public ngOnInit() {
    this._titleService.setTitle(this.title);
  }

}
